import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EcddModel } from '@shared/data-access/models';

import { EcddAction } from '../actions';
import { EcddSelector } from '../selectors';

@Injectable({
  providedIn: 'root',
})
export class EcddFacade {
  selectedItem$ = this._store.select(EcddSelector.selectItemDetail);

  constructor(private _store: Store) { }

  setItemDetail(item: EcddModel | null) {
    this._store.dispatch(EcddAction.setItemDetail({ item }));
  }

  loadItemDetail(id: number) {
    this._store.dispatch(EcddAction.loadItemDetail({ id }));
  }

}
